<template>
  <v-container>
    <h2>Admin Panel</h2>
    <v-table>
      <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Role</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in users" :key="user.uid">
          <td>{{ user.name }}</td>
          <td>{{ user.email }}</td>
          <td>{{ user.role }}</td>
          <td>{{ formatTimestamp(user.createdAt) }}</td>
          <td>
            <v-btn
              v-if="user.role !== 'admin'"
              @click="makeAdmin(user.uid)"
              size="small"
            >
              Make Admin
            </v-btn>
          </td>
        </tr>
      </tbody>
    </v-table>
  </v-container>
</template>

<script setup>
import { ref, onMounted } from "vue";
import {
  getFirestore,
  collection,
  query,
  getDocs,
  updateDoc,
  doc,
} from "firebase/firestore";

const db = getFirestore();
const users = ref([]);

const loadUsers = async () => {
  const q = query(collection(db, "users"));
  const snapshot = await getDocs(q);
  users.value = snapshot.docs.map((doc) => ({ uid: doc.id, ...doc.data() }));
};

const makeAdmin = async (userId) => {
  try {
    await updateDoc(doc(db, "users", userId), {
      role: "admin",
    });
    await loadUsers();
    alert("User role updated to admin");
  } catch (error) {
    console.error("Error updating user role:", error);
  }
};
const formatTimestamp = (timestamp) => {
  if (!timestamp || typeof timestamp.seconds === "undefined") {
    return "Invalid Date";
  }
  const date = new Date(timestamp.seconds * 1000);

  // Use toLocaleString with options for 24-hour format
  return date.toLocaleString("en-GB", {
    // 'en-GB' locale often defaults to 24-hour.
    // Or specify options explicitly:
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false, // This is key for 24-hour format
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  // Manual 24-hour format (if you want full control)
  // const year = date.getFullYear();
  // const month = String(date.getMonth() + 1).padStart(2, '0');
  // const day = String(date.getDate()).padStart(2, '0');
  // const hours = String(date.getHours()).padStart(2, '0'); // getHours() gives 0-23
  // const minutes = String(date.getMinutes()).padStart(2, '0');
  // const seconds = String(date.getSeconds()).padStart(2, '0');
  // return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

onMounted(() => {
  loadUsers();
});
</script>
